import { useContext } from 'react'
import useOneOffPaymentTargetPaymentTargetCorrectionPaymentObjectivesAndTargetBonusOfYear from '../../../../../graphql/one-off-payment/hooks/useOneOffPaymentTargetPaymentTargetCorrectionPaymentObjectivesAndTargetBonusOfYear'
import { MeetingStepStatus, MeetingStepViewId, ObjectivePaymentStatus } from '../../../../../types'
import { AppraisalFlowContext } from '../../shared/AppraisalFlowProvider'
import { updateMeetingStep } from '../../shared/AppraisalMeetingService'

export const usePastTargetsWithPaymentsValidator = (): void => {
  const { meeting, meetingTypeSteps } = useContext(AppraisalFlowContext)
  const paymentStep = meetingTypeSteps.find((step) => step.viewId === MeetingStepViewId.Payments)

  const { loading, error, data } = useOneOffPaymentTargetPaymentTargetCorrectionPaymentObjectivesAndTargetBonusOfYear(
    meeting.employee.id,
    meeting.id,
    meeting.targetsCalculationHelper.pastTargetsReferenceYear,
    true,
  )

  if (!loading && !error && !!data) {
    const objectivePayment = data.objectivePayment
      ? data.objectivePayment
      : { id: null, meetingId: meeting.id, status: ObjectivePaymentStatus.Draft, deduction: null, paymentDateValid: true }

    if (paymentStep && paymentStep.status === MeetingStepStatus.Done && !objectivePayment.paymentDateValid) {
      updateMeetingStep(paymentStep.id, MeetingStepStatus.Incomplete)
    } else if (paymentStep && paymentStep.status === MeetingStepStatus.Incomplete && objectivePayment.paymentDateValid) {
      updateMeetingStep(paymentStep.id, MeetingStepStatus.Done)
    }
  }
}
